var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoIrPara01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    className: "st0",
    width: 35.8,
    height: 35.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "go_to",
    d: "M31.2,22.3c-1.2,0-2.3-0.4-3.1-1.2c-0.8-0.8-1.3-1.9-1.3-3.1c0-1.2,0.5-2.3,1.3-3.1c1.7-1.7,4.4-1.7,6.1-0.1 c0.8,0.8,1.3,2,1.3,3.2c0.1,2.3-1.8,4.3-4.1,4.3C31.4,22.4,31.3,22.4,31.2,22.3L31.2,22.3z M18,22.3c-1.2,0-2.3-0.4-3.1-1.2 c-0.8-0.8-1.3-1.9-1.3-3.1c0-1.2,0.5-2.3,1.3-3.1c0.8-0.8,1.9-1.3,3.1-1.2c2.3-0.1,4.3,1.8,4.3,4.1c0,0.1,0,0.1,0,0.2 c0.1,2.3-1.8,4.3-4.1,4.3C18.2,22.4,18.1,22.4,18,22.3z M4.9,22.3c-1.2,0-2.3-0.4-3.1-1.2C1,20.3,0.5,19.2,0.5,18 c0-1.2,0.5-2.3,1.3-3.1c0.8-0.8,1.9-1.3,3.1-1.2c2.3-0.1,4.3,1.8,4.3,4.1c0,0.1,0,0.1,0,0.2c0.1,2.3-1.8,4.3-4.1,4.3 C5,22.4,5,22.4,4.9,22.3L4.9,22.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoIrPara01);
export default __webpack_public_path__ + "static/media/ico-ir-para-01.0ad6cccaf9855757e27811fc65766f6c.svg";
export { ForwardRef as ReactComponent };